import { ReactComponent as LvivPolytechnicLogo } from '../../assets/logo.education.svg'
import "./Education.scss";

function Education() {
  return (
    <>
      <h2>Education</h2>
      <div className="education">
        <div className="education__logo">
          <LvivPolytechnicLogo />
        </div>
        <div className="education__info">
          <p className="education__info__title">
            Lviv Polytechnic National University
          </p>
          <p>Bachelor's degree, Software engineering</p>
        </div>
        <div className="education__date">
          <span>Sep 2016 - May 2020 (3y 8m)</span>
        </div>
      </div>
    </>
  );
}

export { Education };
